import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const AirplaneIcon = _ref => {
  let {
      size = "13",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M23.0001 15.5756V13.3949L13.6668 7.94307V1.94609C13.6668 1.04109 12.8851 0.310547 11.9168 0.310547C10.9484 0.310547 10.1668 1.04109 10.1668 1.94609V7.94307L0.833435 13.3949V15.5756L10.1668 12.8497V18.8467L7.83344 20.4822V22.1178L11.9168 21.0274L16.0001 22.1178V20.4822L13.6668 18.8467V12.8497L23.0001 15.5756Z",
    fill: color
  }));
};
export default AirplaneIcon;